module.exports = __webpack_public_path__ + "static/media/la-picture-2.f711a318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-2.jpg
// module id = 652
// module chunks = 1 16 35